
  import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
  export default class TimeIcon extends Vue {
    @Prop({ required: true }) title!: string;
  }
  